/** Where the cards stand when the map was the first Learn route (a deep link, a restored state). */
export const LEARN_MAP_DEFAULT_CARDS_PATHNAME = "/learn/summary";
